import { render, staticRenderFns } from "./dialogStructureMessage.vue?vue&type=template&id=c4c002a4&"
import script from "./dialogStructureMessage.vue?vue&type=script&lang=js&"
export * from "./dialogStructureMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports